import { Component, OnInit } from "@angular/core";
import { SiteSEOHelperService } from "src/app/services/siteseoHelper.service";
import { DResult } from "src/app/models/common.models/dresult.model";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { API_ServerAddress } from "src/app/MyAppCommonConfig";
import { ProductGetDetailOutputDTO } from "src/app/models/products.models/product.models/productGetDetailOutputDTO.model";
import { ProductsSiteService } from "src/app/services/productsSite.service";
import { ProductCustomersSiteService } from "src/app/services/productCustomersSite.service";
import { ProductSpecificationsSiteService } from "src/app/services/productSpecificationsSite.service";
import { ProductSpecificationGetListByProductIdOutputDTO } from "src/app/models/products.models/ProductSpecification.models/ProductSpecificationGetListByProductIdOutputDTO.model";
import { ProductCustomerGetListByProductIdOutputDTO } from "src/app/models/products.models/productCustomer.models/productCustomerGetListByProductIdOutputDTO.model";
import { OwlOptions } from "ngx-owl-carousel-o/public_api";
import { ProductGetListByProductTypeIdOutputDTO } from "src/app/models/products.models/product.models/productGetListByProductTypeIdOutputDTO.model";
import { switchMap } from "rxjs/operators";
import { ProductImagesSiteService } from "src/app/services/productImagesSite.service";
import { ProductImageGetListByProductIdOutputDTO } from "src/app/models/products.models/ProductImage.models/ProductImageGetListByProductIdOutputDTO.model";

@Component({
  selector: "productdetails",
  templateUrl: "productdetails.component.html"
})
export class ProductDetailsComponent implements OnInit {
  ngOnInit(): void {
    this.route.paramMap
      .pipe(
        switchMap((params: ParamMap) => {
          this.id = Number(params.get("id"));
          return this.GetItemDetail();
        })
      )
      .subscribe((data: DResult<ProductGetDetailOutputDTO>) => {
        if (data.isSuccess) {
          this.itemDetail = data.result;
          this.ImageAddress =
            this.APIServerAddress + this.itemDetail.imageAddressHighQuality;

          if (this.itemDetail.videoAddress != null && this.itemDetail.videoAddress.length > 0) {
            this.HasVideo = true;
          } else {
            this.HasVideo = false;
          }

          this.siteSEOHelperService.SetPageMetaData(
            this.itemDetail.metaTitle,
            this.itemDetail.metaDescription,
            this.itemDetail.metaKeywords
          );

          this.GetItemDetail();
          this.GetProductImages();
          this.GetProductSpecifications();
          this.GetProductCustomers();
          this.GetRelatedProducts();
        }
      });
  }

  APIServerAddress: string = API_ServerAddress;
  id: number;
  itemDetail: ProductGetDetailOutputDTO = new ProductGetDetailOutputDTO();
  productSpecifications: ProductSpecificationGetListByProductIdOutputDTO[] = [];
  productCustomers: ProductCustomerGetListByProductIdOutputDTO[] = [];
  productImages: ProductImageGetListByProductIdOutputDTO[] = [];
  relatedProducts: ProductGetListByProductTypeIdOutputDTO[] = [];
  ImageAddress: string = "#";
  HasVideo: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private siteSEOHelperService: SiteSEOHelperService,
    private productsSiteService: ProductsSiteService,
    private productSpecificationsSiteService: ProductSpecificationsSiteService,
    private productCustomersSiteService: ProductCustomersSiteService,
    private productImagesSiteService: ProductImagesSiteService
  ) {
    this.id = +this.route.snapshot.paramMap.get("id");
  }

  GetItemDetail() {
    return this.productsSiteService.GetById(this.id);
  }

  GetProductSpecifications() {
    this.productSpecificationsSiteService
      .GetListByProductId(this.id)
      .subscribe(
        (data: DResult<ProductSpecificationGetListByProductIdOutputDTO[]>) => {
          if (data.isSuccess) {
            this.productSpecifications = data.result;
          }
        }
      );
  }

  GetProductCustomers() {
    this.productCustomersSiteService
      .GetListByProductId(this.id)
      .subscribe(
        (data: DResult<ProductCustomerGetListByProductIdOutputDTO[]>) => {
          if (data.isSuccess) {
            this.productCustomers = data.result;
          }
        }
      );
  }

  GetProductImages() {
    this.productImagesSiteService
      .GetListByProductId(this.id)
      .subscribe((data: DResult<ProductImageGetListByProductIdOutputDTO[]>) => {
        if (data.isSuccess) {
          this.productImages = data.result;
        }
      });
  }

  GetRelatedProducts() {
    this.productsSiteService
      .GetTopByProductTypeId(12, this.itemDetail.productTypeId)
      .subscribe((data: DResult<ProductGetListByProductTypeIdOutputDTO[]>) => {
        if (data.isSuccess) {
          this.relatedProducts = data.result;
        }
      });
  }

  SetDefaultPhoto(photoId: number = 0) {
    if (this.productImages != null && this.productImages.length > 0) {
      if (photoId > 0) {
        var itemImage = this.productImages.find(p => p.id == photoId);
        this.ImageAddress =
          this.APIServerAddress + itemImage.imageAddressHighQuality;
      }
    }
  }

  MakeShortDescription(input: string, maxChar: number) {
    if (input.length <= maxChar) {
      return input;
    } else {
      return input.substring(0, maxChar) + " . . . ";
    }
  }

  relatedProductsSliderOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    navText: ["", ""],
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 2
      },
      1000: {
        items: 4
      }
    },
    nav: true,

    //Important !!
    autoplay: true,
    //Important for rtl page !!
    rtl: true,

    margin: 10
  };
}
